import React from 'react';
import {
    Paper,
    Typography,
    Divider,
    Grid,
    Box,
} from '@mui/material';

interface Step5SimViewProps {
    data: {
        hasCertification: boolean | null;
        certificationSoldInFairs: boolean | null;
        hasMunicipalSeal: boolean | null;
        municipalSealName: string;
        wantsMunicipalSeal: boolean | null;
        knowsHowToCreateSeal: boolean | null;
        referenceYear: number;
    };
}

const booleanText = (value: boolean | null) =>
    value === true ? 'Sim' : value === false ? 'Não' : 'Não informado';

const Step5SimView: React.FC<Step5SimViewProps> = ({ data }) => (
    <Paper elevation={1} sx={{ p: 3, mt: 2 }}>
        <Typography variant="h5" color="primary" gutterBottom>
            Certificação e Selo Municipal
        </Typography>
        <Divider sx={{ mb: 3 }} />

        <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 2 }}>
            Ano de referência do Questionário: <b>{data.referenceYear}</b>
        </Typography>

        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography variant="subtitle2">
                    O município possui produto(s) da agricultura familiar com certificação ou identificação?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    {booleanText(data.hasCertification)}
                </Typography>
            </Grid>

            {data.hasCertification && (
                <Grid item xs={12}>
                    <Typography variant="subtitle2">
                        Esses produtos com certificação ou identificação são vendidos em feiras da agricultura familiar?
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                        {booleanText(data.certificationSoldInFairs)}
                    </Typography>
                </Grid>
            )}

            {data.hasCertification && (
                <>
                    <Grid item xs={12}>
                        <Typography variant="subtitle2">
                            O município possui selo próprio (municipal) para agregação de valor e/ou identificação de produtos da agricultura familiar?
                        </Typography>
                        <Typography variant="body1" sx={{ mb: 2 }}>
                            {booleanText(data.hasMunicipalSeal)}
                        </Typography>
                    </Grid>

                    {data.hasMunicipalSeal && (
                        <Grid item xs={12}>
                            <Typography variant="subtitle2">
                                Nome do selo municipal:
                            </Typography>
                            <Typography variant="body1" sx={{ mb: 2 }}>
                                {data.municipalSealName || 'Não informado'}
                            </Typography>
                        </Grid>
                    )}

                    <Grid item xs={12}>
                        <Typography variant="subtitle2">
                            O município tem interesse em criar um selo municipal para agregação de valor e/ou identificação de produtos da agricultura familiar?
                        </Typography>
                        <Typography variant="body1" sx={{ mb: 2 }}>
                            {booleanText(data.wantsMunicipalSeal)}
                        </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="subtitle2">
                            O município sabe como criar um selo municipal de agregação de valor e/ou identificação de produtos da agricultura familiar?
                        </Typography>
                        <Typography variant="body1" sx={{ mb: 2 }}>
                            {booleanText(data.knowsHowToCreateSeal)}
                        </Typography>
                    </Grid>
                </>
            )}
        </Grid>
    </Paper>
);

export default Step5SimView;